// extracted by mini-css-extract-plugin
export default {"cnt-text-fld":"Contact_cnt-text-fld__FEbM9","error-message":"Contact_error-message__5+ObP","cnt-label":"Contact_cnt-label__ICuKK","submit-btn":"Contact_submit-btn__4ktow"};